import hljs from 'highlight.js';

class ArcscriptLanguagePlugin {
  constructor(options) {
    this.prefix = options.dataPrefix;
    this.callDepth = 0;
    this.mentions = {};
  }

  /**
   * Replace all the mentions with a text node indicating a mention
   */
  'before:highlightElement'({ el, language }) {
    const qs = el.querySelectorAll('span.mention, span.hljs-mention');
    qs.forEach(mention => {
      const id = mention.getAttribute('data-id');
      const type = mention.getAttribute('data-type');
      this.mentions[id] = mention;
      mention.parentNode.replaceChild(
        document.createTextNode(`hljs-mention.${type}[${id}]`),
        mention
      );
    });
    el.innerHTML = el.innerText;
  }

  /**
   * Replace add the mention type and id in the mention node and replace the textContent with the original
   */
  'after:highlightElement'({ el, result, text }) {
    const qs = el.querySelectorAll('span.hljs-mention');
    qs.forEach(mention => {

      // eslint-disable-next-line no-empty-character-class, prettier/prettier
      const matchResult = mention.textContent.match(/hljs-mention\.(?<type>[a-zA-Z0-9]+)\[(?<id>[a-zA-Z0-9-]+)\]/d);
      if (matchResult !== null && matchResult.groups) {
        const { type, id } = matchResult.groups;

        mention.setAttribute('data-type', type);
        mention.setAttribute('data-id', id);
        mention.textContent = this.mentions[id].textContent;
      }
    })
  }
}

export default ArcscriptLanguagePlugin;
